module.exports = __webpack_public_path__ + "86cfd821b9cdcfc8f57f05fdde98f44e.png";